import React from 'react'

// COMPONENTS
import { Typography, Container, Button } from 'components'
import Footer from '../../components/Footer'
import HeaderMenu from '../../containers/HeaderMenu'
import * as routes from '../../settings/_routesSettings'
import { ReactComponent as Icon404} from 'static/svg/icon404.svg'

const CustomError = ({
  title,
  subtitle
}) => {
  return <>
    <HeaderMenu />
    <Container>
      <div className="CustomError">

        <div>
          <Icon404 className="CustomError__Img" />
        </div>

        <Typography
          bold
          align="center"
          color="primary"
          type="custom"
          Tag="h1"
          style={{
            fontSize: '30px',
            fontWeight: '500',
            lineHeight: '27px'
          }}
        >
          {title}
        </Typography>

        <div className="CustomError__Subtitle">
          <Typography
            align="center"
            variant="custom"
            style={{
              fontSize: '15px',
              lineHeight: '19px'
            }}
          >
            {subtitle}
          </Typography>
        </div>

        <div className="CustomError__ButtonBox">
          <a href={routes.HOME_PSIC}>
            <Button extraClass="CustomError__ButtonBox__Button">
              VOLTAR PARA A PÁGINA INICIAL
            </Button>
          </a>
        </div>

      </div>

    </Container>

    <Footer extraClass="CustomError__Footer"/>
  </>
}

export default CustomError
